import { render, staticRenderFns } from "./data-input.vue?vue&type=template&id=9e6f6ac2"
import script from "./data-input.vue?vue&type=script&lang=js"
export * from "./data-input.vue?vue&type=script&lang=js"
import style0 from "./data-input.vue?vue&type=style&index=0&id=9e6f6ac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports